var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.date))+" "),(_vm.diff)?_c('span',{staticClass:"tooltip text-red-600"},[_vm._v(" * "),_c('span',{staticClass:"tooltiptext",staticStyle:{"width":"120px"}},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.order.attributes.createdAt))+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }